<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card text-center" v-bind:id="getId()" style="float:left; width:200px; margin-left:15px;">




    <div class="card-header bg-dark header-elements-inline px-0 pb-1" style="border:none;">
      <div class="row" style="width:100%;">
        <div class="col-10 pl-3 text-left pt-1" style="font-size:10px;">
          {{$t('manage_team')}}
        </div>
        <div class="col-2 pt-1" style="text-align:right;line-height:10px;padding-right:0px">
          <a class="list-icons-item" @click="removeMe" data-action="remove" style="margin-top:-4px;"></a>
        </div>
        <div class="col-12 pl-3 text-left">
          <h6 class="card-title" style="text-transform:uppercase;">{{$store.translate('team')}}: {{config.text}}</h6>
        </div>
      </div>
    </div>

    <div class="card-body p-0 m-0">
      <div class="p-1 m-0" style="height: 74px;">
        <vue-scroll :ops="ops" class="">
          <div class="row pt-1" style="min-height: 100px;">
            <div class="col-12">
              <table class="table">
                <tr v-for="option in teamMembers" class="mt-1">
                  <td align="left" style="max-width:90%">{{ option.ShortName }}</td>
                  <td><a @click="deleteTeamMember(option.Id)"><i class="icon-user-minus"></i></a></td>
                </tr>
              </table>
            </div>
          </div>
        </vue-scroll>
      </div>
      <div class="col-12 pb-2">
        <add-teammember-selector @event-refresh-teammembers="loadTeamMembers" ref="teamSelector"></add-teammember-selector>
      </div>


    </div>



</template>

<script>

  var config =
  {
    customstyle: "background-color:#92D050",
    customclass: "",
    abbreviation: "T1",
    data: 8,
    text: "Team 1",
    icon: null

  }

  import TeamMemberSelector from '../../team/add-teammember-selector.vue'
  import vuescroll from 'vuescroll';

  var teamMembers = [];
  var teamId = 0;
  export default {
    name: "display-team",
    components: {
      TeamMemberSelector,
      vuescroll
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      },
    },
    data() {
      return {
        teamMembers,
        teamId,
        config,
        ops: {
          vuescroll: {
            mode: 'slide',
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            background: '#F6F7F7',
            opacity: 0.5,
            size: '6px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            gutterOfSide: '2px',
            keepShow: false
          },
          bar: {
            onlyShowBarOnScroll: false,
            keepShow: true,
            background: '#666767',
          }
        }
      };
    },

    methods: {
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getId());
      },
      async loadTeamMembers() {       
        try {
          this.teams = [];
          this.$http.get('/api/Team/v1/Members/' + this.teamId).then(async response => {
            this.teamMembers = response.data;            
            this.$refs.teamSelector.teamId = this.teamId;
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async deleteTeamMember(id) {       
        try {          
          this.$http.delete('/api/Team/v1/Members/' + id).then(async response => {
            this.loadTeamMembers();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      setConfig(config) {      
        this.config = config;
        this.teamId = config.data.toString();
        this.loadTeamMembers();
      }
    },
    computed: {

    },
    mounted() {
      vm.$root.$on('statistics', this.recalculate);
      vm.$emit('doSearch');
    },

    created: function () {

    },

    watch: {     
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>

  .card-header.bg-dark {
    background-color: #f6f7f7 !important;
    color: black !important;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .table td {
    padding: 3px !important;
    padding-top:5px;
    border-bottom: 1px solid #ddd;
    border-top: 0px solid #ddd;
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/filter/displayers/display-team.vue